if (!customElements.get('ticker-component')) {
  class TickerComponent extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector('.ticker-controls__btn');
      this.tickerList = this.querySelector('ticker-list');

      if (!this.toggleBtn || !this.tickerList) {
        console.error('Ticker components missing');
        return;
      }

      this.toggle = this.toggle.bind(this);
      this.toggleBtn.addEventListener('click', this.toggle);
      this.addEventListener('click', this.toggle);

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches;

      if (prefersReducedMotion) {
        this.setAttribute('state', 'paused');
      } else {
        this.setAttribute('state', 'playing');
      }
    }

    /**
     * @param {Event} e
     */
    toggle(e) {
      const state = this.getAttribute('state');
      if (state === 'playing') {
        this.setAttribute('state', 'paused');
        this.dispatchEvent(
          new CustomEvent('ticker:toggle', { detail: 'paused', bubbles: true }),
        );
      } else {
        this.setAttribute('state', 'playing');
        this.dispatchEvent(
          new CustomEvent('ticker:toggle', {
            detail: 'playing',
            bubbles: true,
          }),
        );
      }
      e.stopPropagation();
    }
  }

  customElements.define('ticker-component', TickerComponent);
}

if (!customElements.get('ticker-list')) {
  class TickerList extends HTMLElement {
    constructor() {
      super();
      this.isRunning = false;
      this.speed = 50;
      this.wrapperClass = this.dataset.wrapperClass ?? 'ticker__items';

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.tickerComponent = this.closest('ticker-component');

      /** @type {'playing' | 'paused' | 'forcedPaused'} */
      this.state =
        this.tickerComponent.getAttribute('state') === 'playing'
          ? 'playing'
          : 'forcedPaused';

      this.clone();
      this.#animate();

      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.toggle = this.toggle.bind(this);
    }

    connectedCallback() {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.tickerComponent.addEventListener('ticker:toggle', this.toggle);
      this.observe();
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.tickerComponent.removeEventListener('ticker:toggle', this.toggle);
      this.observer?.disconnect();
    }

    /**
     * @param {CustomEvent<'playing' | 'paused'>} e
     */
    toggle(e) {
      const state = e.detail;
      if (state === 'playing') {
        this.play();
      } else {
        this.forcePause();
      }
    }

    observe() {
      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.maybePlay();
          } else {
            this.maybePause();
          }
        },
        {
          rootMargin: '200px 0px',
        },
      );

      this.observer.observe(this);
    }

    clone() {
      const tickerItems = this.innerHTML;
      const wrappedItemsReal = `<div class="${this.wrapperClass}" data-ticker-items>${tickerItems}</div>`;
      const wrappedItemsClone = `<div aria-hidden="true" class="${this.wrapperClass}" data-ticker-items>${tickerItems}</div>`;
      this.innerHTML = wrappedItemsReal + wrappedItemsClone + wrappedItemsClone;
    }

    #animate() {
      this.contentWidth =
        this.querySelector('[data-ticker-items]')?.offsetWidth || 0;
      this.duration = this.contentWidth / this.speed;

      // @ts-ignore
      this.tween = gsap.to(this.querySelectorAll('[data-ticker-items]'), {
        duration: this.duration,
        xPercent: -100,
        ease: 'none',
        repeat: -1,
        paused: this.state !== 'playing',
      });

      this.isRunning = true;
    }

    onMouseEnter() {
      if (this.state !== 'forcedPaused') {
        this.pause();
      }
    }

    onMouseLeave() {
      if (this.state !== 'forcedPaused') {
        this.play();
      }
    }

    maybePlay() {
      if (this.state !== 'forcedPaused') {
        this.play();
      }
    }

    maybePause() {
      if (this.state !== 'forcedPaused') {
        this.pause();
      }
    }

    play() {
      this.state = 'playing';
      this.tween.play();
    }

    forcePause() {
      this.state = 'forcedPaused';
      this.tween.pause();
    }

    pause() {
      this.state = 'paused';
      this.tween.pause();
    }
  }

  customElements.define('ticker-list', TickerList);
}

